import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return (
    <div role="status" aria-label="Wird geladen" className="flex items-center justify-center p-8">
      <Loader2 className={cn("size-5 animate-spin text-muted-foreground", className)} />
    </div>
  );
}
